import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';

export const Absolute = styled(Flex, {
  position: 'absolute',
});
